import { render } from "./iconErrorLoginFailed.vue?vue&type=template&id=e23a8cbc"
const script = {}

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__